/**
 * Child `url`s inside the balance-returned extension.
 *
 * Bare names rather than full URLs: only the parent carries the canonical URL, which is how FHIR
 * shapes a complex extension and what `qh-balance-returned.json` slices on.
 */
export const BALANCE_RETURNED_PART = {
  Amount: "amount",
  ToStatement: "toStatement",
  ReturnedAt: "returnedAt",
} as const;
